import { useAppContext } from 'Context/ReactAppContext';

export function useAuthentication() {
  const appContext = useAppContext();

  return {
    isLogged: appContext.isUserLogged,
    isQuickLogged: appContext.isUserQuickLogged,
  };
}
